import {Component, Input} from '@angular/core';
// 보고서 공통 펼침 정보가 열리고 닫힐 때 높이와 투명도를 자연스럽게 전환
import {animate, state, style, transition, trigger} from '@angular/animations';
import {FlexLayoutModule, FlexModule} from "@ngbracket/ngx-layout";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {NameValue} from "../../../../_model/name-value";


export interface ExtendableContent {
  title: string;
  value: string;
  subValue?: string;
  items: NameValue[],
  explain?: string,
  badges?: string[]
}

@Component({
  selector: 'app-extendable-card',
  standalone: true,
  imports: [
    FlexModule,
    MatIconButton,
    FlexLayoutModule,
    MatIcon
  ],
  // 열림과 닫힘에 각각 안정적인 easing을 적용해 콘텐츠 높이 변화의 덜컹거림을 제거
  animations: [
    trigger('expandCollapse', [
      state('closed', style({height: '0px', opacity: 0, visibility: 'hidden'})),
      state('open', style({height: '*', opacity: 1, visibility: 'visible'})),
      transition('closed => open', [
        style({visibility: 'visible'}),
        animate('320ms cubic-bezier(0.22, 1, 0.36, 1)')
      ]),
      transition('open => closed', animate('260ms cubic-bezier(0.4, 0, 0.2, 1)'))
    ])
  ],
  templateUrl: './extendable-card.component.html',
  styleUrl: './extendable-card.component.scss'
})
export class ExtendableCardComponent {
  @Input()
  content?: ExtendableContent

  // 모든 보고서의 공통 펼침 상태를 한 곳에서 관리
  expanded = false;

  // 카드 버튼에서 공통 펼침 상태를 전환
  toggle(): void {
    this.expanded = !this.expanded;
  }
}
